<template>
  <div id="mainContent" class="scene-detail content">

    <!-- 日期选择器 -->
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:20px;background:white;position:relative;">
        <div class="searchWarp">
          <!-- 公司选择 -->
          <el-date-picker v-model="searchObj.selectDate" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch" />
          <el-input v-model="searchObj.sn" style="display: none;" :placeholder="$t('kisae.DeviceName')" class="input-with-select deviceNameTable" clearable @clear="changeSearch">
            <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
          </el-input>
        </div>
        <el-button v-if="isShowDownBtn" icon="el-icon-download" size="mini" style="vertical-align: top;margin:5px 10px;float: right;position: relative;z-index: 999;" type="primary" @click="download" />
        <el-tabs v-model="activeTab" type="border-card">
          <el-tab-pane :label="$t('kisae.KisaeBroadcastData')" name="broadcastPane" style="position:relative;">
            <el-table :data="broadcastList" border style="width: auto" fit class="myTable">
              <el-table-column :label="$t('kisae.DeviceName')" prop="sn" align="center" />
              <el-table-column :label="$t('kisae.CreatedAt')" prop="createTime" align="center" />
              <el-table-column :label="$t('kisae.SOC')+'(%)'" prop="bat.soc" align="center" />
              <el-table-column :label="$t('kisae.Current')+'(A)'" prop="bat.batCurrent" align="center" />
              <el-table-column :label="$t('kisae.Voltage')+'(V)'" prop="bat.batVoltage" align="center" />
              <el-table-column :label="$t('kisae.Temperature') + '('+ temUnit +')'" prop="bat.batTemp" align="center" />

              <el-table-column label="RSSI" prop="rssi" align="center" />
              <!-- <el-table-column min-width="40%" :label="$t('kisae.jsonData')" prop="jsonData" align="center" /> -->
              <el-table-column :label="$t('QR.Uploader')" prop="createBy" align="center" />
            </el-table>
            <!-- 列表模块————分页 -->
            <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
              <div class="pagination-container">
                <el-pagination
                  v-if="pageshow"
                  background
                  current-page.sync="broadcastQuery.pageInfo.page"
                  :page-sizes="broadcastQuery.pageInfo.pageList"
                  :page-size="broadcastQuery.pageInfo.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="broadcastQuery.pageInfo.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('kisae.KisaeLiBatteryDetailData')" name="liBatteryDetailDataPane" style="position:relative;">
            <el-table :data="liBatteryDetailList" border style="width: auto" fit class="myTable">
              <el-table-column :label="$t('kisae.DeviceName')" prop="name" align="center" />
              <el-table-column :label="$t('kisae.CreatedAt')" prop="CreatedAt" align="center" />
              <el-table-column :label="$t('kisae.SOC')+'(%)'" prop="soc" align="center" />
              <el-table-column :label="$t('kisae.Current')+'(A)'" prop="current" align="center" />
              <el-table-column :label="$t('kisae.Voltage')+'(V)'" prop="voltage" align="center" />
              <el-table-column :label="$t('kisae.Temperature') + '('+ temUnit +')'" prop="battery_temp" align="center" />
              <el-table-column :label="$t('kisae.BmsStatus')" prop="bms_status" align="center">
                <template slot-scope="scope">
                  <div>
                    <p v-if="scope.row.bms_status=='0'">{{ $t('basicinfo.Idle') }}</p>
                    <p v-else-if="scope.row.bms_status=='1'">{{ $t('basicinfo.DisCharged') }}</p>
                    <p v-else-if="scope.row.bms_status=='2'">{{ $t('basicinfo.Charging') }}</p>
                    <p v-else>--</p>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column :label="$t('kisae.ErrorCode')" prop="ErrorCode" align="center" /> -->
              <el-table-column width="200" :label="$t('QR.Uploader')" prop="createBy" align="center" />
            </el-table>
            <!-- 列表模块————分页 -->
            <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
              <div class="pagination-container">
                <el-pagination
                  v-if="pageshow"
                  background
                  current-page.sync="liBatteryDetailQuery.pageInfo.page"
                  :page-sizes="liBatteryDetailQuery.pageInfo.pageList"
                  :page-size="liBatteryDetailQuery.pageInfo.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="liBatteryDetailQuery.pageInfo.total"
                  @size-change="handleLiBatteryDetailSizeChange"
                  @current-change="handleLiBatteryDetailCurrentChange"
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('kisae.KisaeInverterDetailData')" name="inverterDetailDataPane" style="position:relative;">
            <el-table :data="inverterDetailList" border style="width: auto" fit class="myTable">
              <el-table-column type="expand" style="border-right: none;">
                <template slot-scope="scope">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.MachineModel')">
                        <span>{{ scope.row.MachineModel }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.MachineStatus')">
                        <span>{{ scope.row.MachineStatus }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.AcInCurrent')">
                        <span>{{ scope.row.AcInCurrent }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.AcInEfficiency')">
                        <span>{{ scope.row.AcInEfficiency }} %</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.AcInFrequency')">
                        <span>{{ scope.row.AcInFrequency }} Hz</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.AcInPower')">
                        <span>{{ scope.row.AcInPower }} W</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.AcInTime')">
                        <span>{{ scope.row.AcInTime }} s</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.AcInVoltage')">
                        <span>{{ scope.row.AcInVoltage }} V</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.BatChgCurrent')">
                        <span>{{ scope.row.BatChgCurrent }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.BatChgStage')">
                        <span>{{ scope.row.BatChgStage }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.BatOutCurrent')">
                        <span>{{ scope.row.BatOutCurrent }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.BatType')">
                        <span>{{ scope.row.BatType }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.BatVoltage')">
                        <span>{{ scope.row.BatVoltage }} V</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.BtsTemperature')">
                        <span>{{ scope.row.BtsTemperature }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.ConfigChgCurrent')">
                        <span>{{ scope.row.ConfigChgCurrent }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.ConfigChgVoltage')">
                        <span>{{ scope.row.ConfigChgVoltage }} V</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.DcMosTemperature')">
                        <span>{{ scope.row.DcMosTemperature }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.DisplayProgramRev')">
                        <span>{{ scope.row.DisplayProgramRev }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.DisplayDataRev')">
                        <span>{{ scope.row.DisplayDataRev }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.ErrorCode')">
                        <span>{{ scope.row.ErrorCode }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.InvAcOutCurrent')">
                        <span>{{ scope.row.InvAcOutCurrent }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.InvAcOutEfficiency')">
                        <span>{{ scope.row.InvAcOutEfficiency }} %</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.InvAcOutFrequency')">
                        <span>{{ scope.row.InvAcOutFrequency }} Hz</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.InvAcOutPower')">
                        <span>{{ scope.row.InvAcOutPower }} W</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.InvAcOutTime')">
                        <span>{{ scope.row.InvAcOutTime }} s</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.InvAcOutVoltage')">
                        <span>{{ scope.row.InvAcOutVoltage }} V</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.MainProgramRev')">
                        <span>{{ scope.row.MainProgramRev }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.MainDataRev')">
                        <span>{{ scope.row.MainDataRev }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.RelayTemperature')">
                        <span>{{ scope.row.RelayTemperature }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.TransfTemperature')">
                        <span>{{ scope.row.TransfTemperature }}</span>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column :label="$t('kisae.DeviceName')" prop="name" align="center" />
              <el-table-column :label="$t('kisae.CreatedAt')" prop="CreatedAt" align="center" />
              <el-table-column :label="$t('kisae.MachineModel')" prop="MachineModel" align="center" />
              <el-table-column :label="$t('kisae.MachineStatus')" prop="MachineStatus" align="center" />
              <el-table-column :label="$t('kisae.AcMosTemperature') + '('+ temUnit +')'" prop="AcMosTemperature" align="center" />
              <el-table-column :label="$t('kisae.AmbientTemperature') + '('+ temUnit +')'" prop="AmbientTemperature" align="center" />
              <el-table-column :label="$t('kisae.ErrorCode')" prop="ErrorCode" align="center" />
              <el-table-column width="200" :label="$t('QR.Uploader')" prop="createBy" align="center" />
            </el-table>
            <!-- 列表模块————分页 -->
            <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
              <div class="pagination-container">
                <el-pagination
                  v-if="pageshow"
                  background
                  current-page.sync="inverterDetailQuery.pageInfo.page"
                  :page-sizes="inverterDetailQuery.pageInfo.pageList"
                  :page-size="inverterDetailQuery.pageInfo.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="inverterDetailQuery.pageInfo.total"
                  @size-change="handleInverterDetailSizeChange"
                  @current-change="handleInverterDetailCurrentChange"
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('kisae.KisaeInverterConfigData')" name="inverterConfigDataPane" style="position:relative;">
            <el-table :data="inverterConfigList" border style="width: auto" fit class="myTable">
              <el-table-column type="expand" style="border-right: none;">
                <template slot-scope="scope">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('basicinfo.SystemVoltage')">
                        <span>{{ scope.row.volSystem }} V</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.currBUL')">
                        <span>{{ scope.row.currBUL }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.currFloat')">
                        <span>{{ scope.row.currFloat }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.currSystem')">
                        <span>{{ scope.row.currSystem }} A</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.inverterStatus')">
                        <span>{{ scope.row.inverterStatus }} </span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.rechargeVol')">
                        <span>{{ scope.row.rechargeVol }} V</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.savePower')">
                        <span>{{ scope.row.savePower }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.volABS')">
                        <span>{{ scope.row.volABS }} V</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :lg="8">
                      <el-form-item :label="$t('kisae.volFloat')">
                        <span>{{ scope.row.volFloat }} V</span>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column :label="$t('kisae.DeviceName')" prop="name" align="center" />
              <el-table-column :label="$t('kisae.CreatedAt')" prop="CreatedAt" align="center" />
              <el-table-column :label="$t('kisae.acChargeSwitch')" prop="acChargeSwitchZh" align="center" />
              <el-table-column :label="$t('kisae.acCurLimit')+'(A)'" prop="acCurLimitZh" align="center" />
              <el-table-column :label="$t('kisae.alarmSwitch')" prop="alarmSwitchZh" align="center" />
              <el-table-column :label="$t('kisae.batLowVolAlarm')+'(V)'" prop="batLowVolAlarm" align="center" />
              <el-table-column :label="$t('kisae.batLowVolProtect')+'(V)'" prop="batLowVolProtect" align="center" />
              <el-table-column :label="$t('kisae.batLowVolRst')+'(V)'" prop="batLowVolRst" align="center" />
              <el-table-column :label="$t('kisae.batTemp')" prop="batTemp" align="center" />
              <el-table-column :label="$t('kisae.BatType')" prop="BatType" align="center" />
            </el-table>
            <!-- 列表模块————分页 -->
            <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
              <div class="pagination-container">
                <el-pagination
                  v-if="pageshow"
                  background
                  current-page.sync="inverterConfigQuery.pageInfo.page"
                  :page-sizes="inverterConfigQuery.pageInfo.pageList"
                  :page-size="inverterConfigQuery.pageInfo.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="inverterConfigQuery.pageInfo.total"
                  @size-change="handleInverterConfigSizeChange"
                  @current-change="handleInverterConfigCurrentChange"
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('kisae.backupPowerConfig')" name="backupPowerDataPane" style="position:relative;">
            <el-table :data="backupPowerList" border style="width: auto" fit class="myTable">
              <el-table-column :label="$t('kisae.DeviceName')" prop="name" align="center" />
              <el-table-column :label="$t('kisae.CreatedAt')" prop="CreatedAt" align="center" />
              <el-table-column :label="$t('kisae.inverterStatus')" prop="inverterStatus" align="center" />
              <el-table-column :label="$t('kisae.ecoMode')" prop="ecoMode" align="center" />
              <el-table-column :label="$t('kisae.shutdownCurrent')" prop="shutdownCurrent" align="center" />
              <el-table-column :label="$t('kisae.alarmSwitch')" prop="buzzerSwitch" align="center" />
              <el-table-column :label="$t('kisae.acCurLimit')" prop="acCurLimit" align="center" />
              <el-table-column :label="$t('kisae.defines')" prop="defines" align="center" />
              <el-table-column :label="$t('QR.Uploader')" prop="createBy" align="center" />
            </el-table>
            <!-- 列表模块————分页 -->
            <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
              <div class="pagination-container">
                <el-pagination
                  v-if="pageshow"
                  background
                  current-page.sync="backupPowerQuery.pageInfo.page"
                  :page-sizes="backupPowerQuery.pageInfo.pageList"
                  :page-size="backupPowerQuery.pageInfo.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="backupPowerQuery.pageInfo.total"
                  @size-change="handleBackupPowerSizeChange"
                  @current-change="handleBackupPowerCurrentChange"
                />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { pageBluetoothData } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime'
import { temUnit, temChange, temChangeUnit } from '@/utils/temChange'
import store from '@/store'
import i18n from '@/i18n'

export default {
  data() {
    return {
      // 分页----start
      broadcastQuery: {
        pageInfo: pagination()
      },
      liBatteryDetailQuery: {
        pageInfo: pagination()
      },
      inverterDetailQuery: {
        pageInfo: pagination()
      },
      inverterConfigQuery: {
        pageInfo: pagination()
      },
      backupPowerQuery: {
        pageInfo: pagination()
      },
      pageshow: true,
      // 分页----end
      basicinfo: {},
      searchObj: {
        sn: '',
        selectDate: [new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000] // 默认一周
      },
      activeTab: 'broadcastPane',
      broadcastList: [],
      liBatteryDetailList: [],
      inverterDetailList: [],
      inverterConfigList: [],
      backupPowerList: [],
      lineHeight: '600px',
      temUnit: temUnit(),
      isShowDownBtn: true
    }
  },
  computed: {
    switchArr() {
      return [i18n.t('BondOrUpdateDevice.On'), i18n.t('BondOrUpdateDevice.Off')]
    },
    switchNoYesArr() {
      return [i18n.t('allDeviceDetail.Yes'), i18n.t('allDeviceDetail.no')]
    },
    batTempOption() { // 电池温度补偿
      return [
        { key: 1, label: i18n.t('allDeviceDetail.Bad') },
        { key: 2, label: i18n.t('allDeviceDetail.Normal') },
        { key: 3, label: i18n.t('kisae.high') }
      ]
    }
  },
  watch: {
    activeTab(newValue, oldValue) {
      this.isShowDownBtn = true
      if (newValue == 'broadcastPane') {
        this.queryBroadcast()// 获取广播数据
      } else if (newValue == 'liBatteryDetailDataPane') {
        this.queryLiBatteryDetailData()// 获取锂电池详情数据
      } else if (newValue == 'inverterDetailDataPane') {
        this.queryInverterDetailData()// 获取逆变器详情数据
      } else if (newValue == 'inverterConfigDataPane') {
        this.isShowDownBtn = false
        this.queryInverterConfigData()// 获取逆变器配置数据
      } else if (newValue == 'backupPowerDataPane') {
        this.isShowDownBtn = false
        this.queryBackupPowerData()// 获取后备电源配置数据
      }
    }
  },
  mounted() {
    this.searchObj.sn = this.$route.query.name

    this.queryBroadcast() // 获取广播数据
    // this.queryLiBatteryDetailData() // 获取锂电池详情数据
    // this.queryInverterDetailData() // 获取逆变器详情数据
    // this.queryInverterConfigData() // 获取逆变器配置数据
  },
  methods: {
    queryBroadcast() { // 获取广播数据
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        // 'mcuId': '001c00115847501420303142',
        'mcuId': this.searchObj.sn,
        pageNum: this.broadcastQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.broadcastQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 10
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.broadcastList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        // this.broadcastList = res.resultModel.list

        const tables = []
        const list = res.resultModel.list
        list.forEach(item => {
          const obj = item
          obj.sn = item.mcuId
          obj.createTime = getDateAndHour(item.createTime)

          let object = {}
          if (item.jsonData) {
            object = JSON.parse(item.jsonData)
            for (const key in object) {
              if (Object.hasOwnProperty.call(object, key)) {
                obj[key] = object[key]
              }
            }
          }
          tables.push(obj)
        })
        console.log('广播数据：', tables)
        this.broadcastList = tables

        // res.resultModel.list.forEach(v => {
        //   var obj = {}
        //   if (v.jsonData && v.jsonData.indexOf('{') > -1) obj = JSON.parse(v.jsonData)
        //   obj.jsonData = '--'
        //   for (var attr in obj) {
        //     if (attr == 'bat' || attr == 'inv1' || attr == 'inv2' || attr == 'inv3') {
        //       obj.jsonData = `${attr}: ${JSON.stringify(obj[attr])}`
        //     }
        //   }
        //   obj.createBy = v.createBy
        //   obj.createTime = v.createTime
        //   obj.name = v.mcuId
        //   obj.pack_temp = temChange(obj.pack_temp)
        //   this.broadcastList.push(obj)
        // })
        // this.broadcastList.forEach(v => {
        //   v.CreatedAt = getDateAndHour(v.createTime)
        // })
        this.broadcastQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    queryLiBatteryDetailData() { // 获取锂电池详情数据
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        // 'mcuId': '001c00115847501420303142',
        'mcuId': this.searchObj.sn,
        pageNum: this.liBatteryDetailQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.liBatteryDetailQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 11
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.liBatteryDetailList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach(v => {
          var obj = {}
          if (v.jsonData && v.jsonData.indexOf('{') > -1) obj = JSON.parse(v.jsonData)
          obj.createBy = v.createBy
          obj.createTime = v.createTime
          obj.name = v.mcuId
          obj.battery_temp = temChange(obj.battery_pack_temp)
          this.liBatteryDetailList.push(obj)
        })
        this.liBatteryDetailList.forEach(v => {
          v.CreatedAt = getDateAndHour(v.createTime)
        })
        console.log(this.liBatteryDetailList)
        this.liBatteryDetailQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    queryInverterDetailData() { // 获取逆变器详情数据
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        // 'mcuId': '001c00115847501420303142',
        'mcuId': this.searchObj.sn,
        pageNum: this.inverterDetailQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.inverterDetailQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 12
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.inverterDetailList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach(v => {
          var obj = {}
          if (v.jsonData && v.jsonData.indexOf('{') > -1) obj = JSON.parse(v.jsonData)
          obj.createBy = v.createBy
          obj.createTime = v.createTime
          obj.name = v.mcuId
          obj.AcMosTemperature = temChange(obj.AcMosTemperature)
          obj.AmbientTemperature = temChange(obj.AmbientTemperature)

          obj.BtsTemperature = temChange(obj.BtsTemperature) + ' ' + this.temUnit
          obj.DcMosTemperature = temChange(obj.DcMosTemperature) + ' ' + this.temUnit
          obj.TransfTemperature = temChange(obj.TransfTemperature) + ' ' + this.temUnit
          obj.RelayTemperature = temChange(obj.RelayTemperature) + ' ' + this.temUnit

          let BatChgStageStr = ''
          if (obj.BatChgStage == 0) {
            BatChgStageStr = 'bul'
          } else if (obj.BatChgStage == 1) {
            BatChgStageStr = 'ABS'
          } else if (obj.BatChgStage == 2) {
            BatChgStageStr = 'Float'
          } else {
            BatChgStageStr = 'Unknown'
          }
          obj.BatChgStage = BatChgStageStr

          let BatTypeStr = ''
          if (obj.BatType == 1) {
            BatTypeStr = 'GEL'
          } else if (obj.BatType == 2) {
            BatTypeStr = 'AGM'
          } else if (obj.BatType == 3) {
            BatTypeStr = 'FLOODE'
          } else if (obj.BatType == 4) {
            BatTypeStr = 'Lithium'
          } else if (obj.BatType == 5) {
            BatTypeStr = 'Program'
          } else if (obj.BatType == 6) {
            BatTypeStr = 'PSY'
          } else {
            BatTypeStr = 'Unknown'
          }
          obj.BatType = BatTypeStr

          this.inverterDetailList.push(obj)
        })
        this.inverterDetailList.forEach(v => {
          v.CreatedAt = getDateAndHour(v.createTime)
        })
        console.log(this.inverterDetailList)
        this.inverterDetailQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    queryInverterConfigData() { // 获取逆变器配置数据
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        'mcuId': this.searchObj.sn,
        pageNum: this.inverterConfigQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.inverterConfigQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 16
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.inverterConfigList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach((v, i) => {
          var obj = {}
          var item = {}
          if (v.jsonData && v.jsonData.indexOf('{') > -1) item = JSON.parse(v.jsonData)
          for (var attr in item)obj[attr] = item[attr]
          // if (i == 0)console.log('item', item)
          obj.createBy = v.createBy
          obj.CreatedAt = getDateAndHour(v.createTime)
          obj.name = v.mcuId
          obj.acChargeSwitchZh = item.acChargeSwitch ? this.switchArr[0] : this.switchArr[1]
          obj.alarmSwitchZh = item.alarmSwitch ? this.switchArr[0] : this.switchArr[1]
          switch (item.acCurLimit) {
            case 1:obj.acCurLimitZh = '20'; break
            case 2:obj.acCurLimitZh = '30'; break
            case 3:obj.acCurLimitZh = '15'; break
          }
          // obj.batLowVolAlarm = item.batLowVolAlarm * 10
          // obj.batLowVolProtect = item.batLowVolProtect * 10
          // obj.batLowVolRst = item.batLowVolRst * 10
          // obj.volABS = item.volABS * 10
          // obj.volFloat = item.volFloat * 10
          switch (item.currBUL) {
            case 0:obj.currBUL = 80; break
            case 1:obj.currBUL = 60; break
            case 2:obj.currBUL = 40; break
            case 3:obj.currBUL = 25; break
            case 4:obj.currBUL = 10; break
          }
          switch (item.currFloat) {
            case 0:obj.currFloat = 15; break
            case 1:obj.currFloat = 10; break
            case 2:obj.currFloat = 8; break
            case 3:obj.currFloat = 5; break
            case 4:obj.currFloat = 2; break
          }
          this.batTempOption.forEach(m => {
            if (m.key == item.batTemp)obj.batTemp = m.label
          })
          switch (item.batType) {
            case 1:obj.BatType = 'GEL'; break
            case 2:obj.BatType = 'AGM'; break
            case 3:obj.BatType = 'FLOODE'; break
            case 4:obj.BatType = 'Lithium'; break
            case 5:obj.BatType = 'Program'; break
            case 6:obj.BatType = 'PSY'; break
            default:obj.BatType = 'Unknown'; break
          }
          switch (item.currSystem) {
            case 1:obj.currSystem = '40'; break
            case 2:obj.currSystem = '60'; break
            case 3:obj.currSystem = '80'; break
            case 4:obj.currSystem = '100'; break
          }
          switch (item.inverterStatus) {
            case 1:obj.inverterStatus = this.switchArr[0]; break
            case 2:obj.inverterStatus = 'AbU'; break
            case 3:obj.inverterStatus = 'MbU'; break
            case 4:obj.inverterStatus = this.switchArr[1]; break
          }
          switch (item.savePower) {
            case 1:obj.savePower = this.switchArr[1]; break
            case 2:obj.savePower = '15 W'; break
            case 3:obj.savePower = '25 W'; break
          }
          obj.volSystem = item.volSystem == 1 ? 12 : 24
          this.inverterConfigList.push(obj)
        })
        console.log(this.inverterConfigList)
        this.inverterConfigQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    queryBackupPowerData() { // 获取后备电源配置数据
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        'mcuId': this.searchObj.sn,
        pageNum: this.backupPowerQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.backupPowerQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 17
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.backupPowerList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach((v, i) => {
          var obj = {}
          var item = {}
          if (v.jsonData && v.jsonData.indexOf('{') > -1) item = JSON.parse(v.jsonData)
          for (var attr in item)obj[attr] = item[attr]
          obj.createBy = v.createBy
          obj.CreatedAt = getDateAndHour(v.createTime)
          obj.name = v.mcuId
          obj.buzzerSwitch = item.buzzerSwitch ? this.switchArr[0] : this.switchArr[1]
          obj.defines = item.defines ? this.switchNoYesArr[0] : this.switchNoYesArr[1]
          switch (item.inverterStatus) {
            case 1:obj.inverterStatus = this.switchArr[0]; break
            case 2:obj.inverterStatus = 'AbU'; break
            case 3:obj.inverterStatus = 'MbU'; break
            case 4:obj.inverterStatus = this.switchArr[1]; break
          }
          switch (item.ecoMode) {
            case 1:obj.ecoMode = this.switchArr[1]; break
            case 2:obj.ecoMode = '10W'; break
            case 3:obj.ecoMode = '15W'; break
            case 4:obj.ecoMode = '20W'; break
            case 5:obj.ecoMode = '25W'; break
          }
          switch (item.shutdownCurrent) {
            case 1:obj.shutdownCurrent = this.switchArr[1]; break
            case 2:obj.shutdownCurrent = '1A'; break
            case 3:obj.shutdownCurrent = '1.5A'; break
            case 4:obj.shutdownCurrent = '2A'; break
            case 5:obj.shutdownCurrent = '2.5A'; break
          }
          switch (item.acCurLimit) {
            case 1:obj.acCurLimit = '10A'; break
            case 2:obj.acCurLimit = '13A'; break
            case 3:obj.acCurLimit = '16A'; break
          }
          this.backupPowerList.push(obj)
        })
        console.log(this.backupPowerList)
        this.backupPowerQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    changeSearch() { // 改变筛选条件
      if (this.activeTab == 'broadcastPane') { // 获取广播数据
        this.broadcastQuery.pageInfo.pageNum = 1
        this.pageshow = false
        this.queryBroadcast()
      }
      if (this.activeTab == 'liBatteryDetailDataPane') {
        this.liBatteryDetailQuery.pageInfo.pageNum = 1
        this.pageshow = false
        this.queryLiBatteryDetailData()// 获取详情数据
      }
      if (this.activeTab == 'inverterDetailDataPane') {
        this.inverterDetailQuery.pageInfo.pageNum = 1
        this.pageshow = false
        this.queryInverterDetailData()// 获取详情数据
      }
      if (this.activeTab == 'inverterConfigDataPane') {
        this.inverterConfigQuery.pageInfo.pageNum = 1
        this.pageshow = false
        this.queryInverterConfigData()// 获取详情数据
      }
      if (this.activeTab == 'backupPowerDataPane') {
        this.backupPowerQuery.pageInfo.pageNum = 1
        this.pageshow = false
        this.queryBackupPowerData()// 获取详情数据
      }

      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    download() { // 下载
      const temType = store.state.temType || 'ssd'
      const tem = temType === 'ssd' ? 'C' : 'F'

      var param = {
        type: '',
        mcuId: this.searchObj.sn,
        startDate: new Date(this.searchObj.selectDate[0]).getTime(),
        endDate: new Date(this.searchObj.selectDate[1]).getTime(),
        lang: this.$i18n.locale
      }

      console.log(param)
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      if (this.activeTab == 'broadcastPane') { // 广播数据
        param.type = 10
      } else if (this.activeTab == 'liBatteryDetailDataPane') { // 锂电池详情数据
        param.type = 11
      } else if (this.activeTab == 'inverterDetailDataPane') { // 逆变器详情数据
        param.type = 12
      }

      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportKisaeData?mcuId='
      url += param.mcuId + '&type=' + param.type + '&startDate=' + param.startDate + '&endDate=' + param.endDate +
      '&lang=' + param.lang + '&tem=' + tem
      console.log('下载url', url)
      window.open(url, '_bank')
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.broadcastQuery.pageInfo.pageSize = val
      this.queryBroadcast()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.broadcastQuery.pageInfo.pageNum = val
      this.queryBroadcast()
    },
    handleLiBatteryDetailSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.liBatteryDetailQuery.pageInfo.pageSize = val
      this.queryLiBatteryDetailData()
    },
    handleLiBatteryDetailCurrentChange(val, e) { // 选中某一页
      this.liBatteryDetailQuery.pageInfo.pageNum = val
      this.queryLiBatteryDetailData()
    },
    handleInverterDetailSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.inverterDetailQuery.pageInfo.pageSize = val
      this.queryInverterDetailData()
    },
    handleInverterDetailCurrentChange(val, e) { // 选中某一页
      this.inverterDetailQuery.pageInfo.pageNum = val
      this.queryInverterDetailData()
    },
    handleInverterConfigSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.inverterConfigQuery.pageInfo.pageSize = val
      this.queryInverterConfigData()
    },
    handleInverterConfigCurrentChange(val, e) { // 选中某一页
      this.inverterConfigQuery.pageInfo.pageNum = val
      this.queryInverterConfigData()
    },
    handleBackupPowerSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.backupPowerQuery.pageInfo.pageSize = val
      this.queryBackupPowerData()
    },
    handleBackupPowerCurrentChange(val, e) { // 选中某一页
      this.backupPowerQuery.pageInfo.pageNum = val
      this.queryBackupPowerData()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: '微软雅黑';
}
.searchWarp{
  margin-bottom:10px;
}
</style>
